import { useContext } from 'react';
import { PageContext } from '../../contexts';
import { MusicLink } from '../MusicLink';
import { GO_COOKIE_PRIVACY_NOTICE } from 'constants/metrics';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { localeSelector } from 'store/selectors/locale';
import { COOKIE_PRIVACY_NOTICE_LINKS_MAP } from 'constants/locales';

const PrivacyNotice = () => {
  const page = useContext(PageContext);
  const locale = useSelector(localeSelector);
  return (
    <MusicLink
      href={COOKIE_PRIVACY_NOTICE_LINKS_MAP[locale]}
      kind="accent"
      data-id={`${GO_COOKIE_PRIVACY_NOTICE}-${page}`}
    >
      <FormattedMessage id="privacy-notice" defaultMessage="Privacy Notice" />
    </MusicLink>
  );
};

export default PrivacyNotice;
